import { createFeature, createReducer } from '@ngrx/store';

import { newOpportunityReducers } from './new-opportunity.reducer';
import { newOpportunityInitialState } from './new-opportunity.state';

export const newOpportunityFeature = createFeature({
    name: 'newOpportunity',
    reducer: createReducer(newOpportunityInitialState, ...newOpportunityReducers),
});
